import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class HamburgerMenuOffices extends Component {
	constructor() {
		super();

		this.over = false;
		this.alreadyFocused = false;
		this.alreadyBlured = false;

		this.state = {
			hideList: true
		};

		this.hideList = () => {
			this.setState({
				hideList: true
			});
		};

		this.handleKeyDown = (e) => {
			if (e.keyCode === 9) {
				this.pressedTab = true;
			}
		};

		this.handleBlur = () => {
			if (!this.pressedTab) {
				if (this.over) {
					if (this.alreadyBlured) {
						this.alreadyBlured = false;
					} else {
						this.select.focus();
					}
				} else {
					this.hideList();
				}
			} else {
				this.pressedTab = false;
			}
		};

		this.handleClickClickable = (e) => {
			e.stopPropagation();

			if (this.alreadyFocused) {
				this.alreadyFocused = false;
			} else {
				this.alreadyBlured = true;
				this.hideList();
				this.select.blur();
			}
		};

		this.handleMouseOver = () => {
			this.over = true;
		};

		this.handleMouseOut = () => {
			this.over = false;
		};

		document.body.addEventListener('click', () => {
			if (!this.over) {
				this.hideList();
			}
		});

		this.handleFocus = () => {
			this.setState({
				hideList: false
			});

			this.alreadyFocused = true;
		};

		this.handleAnchorBlur = () => {
			this.hideList();
		};
    }

	render() {
		let { display } = this.props || { display: 'none' };
		return (
			<div id="hamburger-offices" className="hamburger-menu" style={{ display }}>
				{this.props.offices &&
				this.props.offices.length > 1 && (
					<ul className="hamburger-menu__ul">
						{this.props.offices.map((item) => (
							<li className="hamburger-menu__li">
								<a
									className="hamburger-menu__link"
									onBlur={this.handleAnchorBlur}
									href="#"
									title={`Zmień jednostkę na ${item.name}`}
								>
									<span aria-hidden="true">{item.name}</span>
								</a>
							</li>
						))}
					</ul>
				)}
			</div>
		);
	}
}

HamburgerMenuOffices.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	offices: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		})
	)
};

HamburgerMenuOffices.defaultProps = {
	offices: []
};
